import { SendEmailTaskSavedDataKeysEnum } from './hooks/tasks/useSendEmailTask';
import { SendTransationalEmailsTaskSavedDataKeysEnum } from './hooks/tasks/useSendTransactionalEmailsTask';
import { GrowAudienceTaskSavedDataKeysEnum } from './hooks/tasks/useGrowAudienceTask';
import { SendEmailsViaApiTaskSavedDataKeysEnum } from './hooks/tasks/useSendEmailsViaApiTask';
import { SendEmailsViaSmtpTaskSavedDataKeysEnum } from './hooks/tasks/useSendEmailsViaSmtpTask';
import { ImportYourContactsTaskSavedDataKeysEnum } from './hooks/tasks/useImportYourContactsTask';
import { AddSendingDomainTaskSavedDataKeysEnum } from './hooks/tasks/useAddSendingDomainTask';

export type OnboardingSavedDataKeys = `${
    | SendEmailTaskSavedDataKeysEnum
    | SendTransationalEmailsTaskSavedDataKeysEnum
    | GrowAudienceTaskSavedDataKeysEnum
    | SendEmailsViaApiTaskSavedDataKeysEnum
    | SendEmailsViaSmtpTaskSavedDataKeysEnum
    | ImportYourContactsTaskSavedDataKeysEnum
    | AddSendingDomainTaskSavedDataKeysEnum}`;
export type OnboardingSavedData = Record<OnboardingSavedDataKeys, boolean>;

export type OnboardingVideoData = {
    videoId: string;
};

export interface OnboardingTaskProps {
    onboardingGoals: OnboardingGoals;
}
export interface OnboardingTask {
    header: string;
    title: string;
    icon: JSX.Element;
    activeStepsIndex: number;
    description: string | JSX.Element;
    steps: OnboardingSteps[];
    isVisible: boolean;
}

export interface OnboardingCardProps extends OnboardingTask {
    cardIndex: number;
    openedCardIndex: number;
    handleOpenedCard(taskIndex: number): void;
    openedStep?: number;
    isFirstNotDoneTask?: boolean;
}

export enum StatusEnum {
    ACTIVE = 'active',
    DONE = 'done',
}

export interface OnboardingStepLink {
    href?: string;
    label: string;
    icon?: JSX.Element;
    target?: string;
}
export interface OnboardingStepItemDefinition {
    title: string;
    features: Array<string | JSX.Element>;
    tip?: string | JSX.Element;
    links?: OnboardingStepLink[];
    secondaryContent: JSX.Element;
    primaryActionTitle: string;
    primaryActionCallback: () => void;
    secondaryActionTitle?: string;
    secondaryActionCallback?: () => void;
    skipSavedDataKey: string;
}

export interface OnboardingStepItem extends OnboardingStepItemDefinition {
    no?: number;
    isSkipped?: boolean;
    isNotReady?: boolean;
    isCompleted?: boolean;
    isActive?: boolean;
    selectedStepsIndex?: number;
}

export interface OnboardingSteps {
    id: string;
    title: string;
    items: OnboardingStepItem[];
    saveAsActive?: () => void;
}

export enum OnboardingGoalsKeysEnum {
    IsSendingMarketingEmailsAnswered = 'isSendingMarketingEmailsAnswered',
    IsSendingTransactionalEmailsAnswered = 'isSendingTransactionalEmailsAnswered',
    IsSendingNewslettersAnswered = 'isSendingNewslettersAnswered',
    IsGrowingAudienceAnswered = 'isGrowingAudienceAnswered',
    IsConnectingViaAPIAnswered = 'isConnectingViaAPIAnswered',
    IsConnectingViaSMTPAnswered = 'isConnectingViaSMTPAnswered',
    IsWantExploreAnswered = 'isWantExploreAnswered',
    IsWantExploreAnsweredOnly = 'isWantExploreAnsweredOnly',
}
export type OnboardingGoals = Record<OnboardingGoalsKeysEnum, boolean>;
